module.exports = __webpack_public_path__ + "static/img/fullscreen-image_easy-to-get-started_768.25d6e07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/job-description-generator/fullscreen-image_easy-to-get-started_768.png
// module id = gfSI
// module chunks = 0